module.exports = __webpack_public_path__ + "static/media/link.8ffa6652.svg";